/*
 * AutoAjax form
 */
$.fn.datepicker.dates['sk'] = {
    days: ["Nedela", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"],
    daysShort: ["Ned", "Pod", "Uto", "Str", "Štv", "Pia", "Sob"],
    daysMin: ["Ne", "Po", "Ut", "St", "Št", "Pi", "So"],
    months: ["Január", "Február", "Marec", "April", "Máj", "Jún", "Júl", "August", "Septembet", "Október", "November", "December"],
    monthsShort: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Júl", "Aug", "Sep", "Okt", "Nov", "Dec"],
};

/*
 * Number format for numbers
 */
Number.prototype.formatMoney = function(c, d, t){
var n = this,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? " " : t,
    s = n < 0 ? "-" : "",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 };

function isValidEmailAddress(emailAddress) {
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
}


//Google on login callback
window.onGoogleYoloLoad = (googleyolo) => {
  //If client is logged in, then does not offer to login via google one tap
  if (
    window.Laravel.data.client && window.Laravel.data.client.id
   || localStorage.getItem('google_auth_error') == 1
   )
    return;

  var hintPromise = googleyolo.hint({
      supportedAuthMethods: [
        "https://accounts.google.com"
      ],
      supportedIdTokenProviders: [
        {
          uri: "https://accounts.google.com",
          clientId: window.Laravel.data.google_client_id,
        }
      ]
    });

  hintPromise.then((credential) => {
    if (credential.idToken) {
        window.location.href = window.Laravel.requests.google_auth+'?one_tap_token='+credential.idToken;

        console.log('user susccessfully logged in', credential);
      }
    }, (error) => {
        console.log(error);

        localStorage.setItem('google_auth_error', 1);
    });
};

/*
 * Auto forms
 */
$(function(){
    $('footer').addClass('visible');

    $('[data-toggle="tooltip"]').tooltip();

    //Disable closing login box
    $('.dropdown-menu').on('click', function(event){
        if ($(this).hasClass('login-box') || $(this).hasClass('stop'))
            event.stopPropagation();
    });

    $('.continue-button a').click(function(){
        $('html, body').animate({
            scrollTop: $("#plannedDelivery").offset().top
        }, 500);

        return false;
    });

    //Change newsletter icon
    $('input[name="newsletter_email"]').keyup(function(){
        var value = $(this).val(),
            i = $(this).parent().find('i');

        if ( isValidEmailAddress(value) )
            i.removeClass('fa-times').addClass('fa-check');
        else
            i.removeClass('fa-check').addClass('fa-times');
    });

    $('.cart-resume-mode-products').each(function(){
        $('.go_basket_resume').click(function(){
            $('html, body').animate({
                scrollTop: $(".cart-delivery .item-summary").offset().top - 50
            }, 500);

            return false;
        });

        $('html, body').animate({
            scrollTop: 69
        }, 500);
    })

    // Vertical gallery in products
    if ( $('#gallery-wrapper').length > 0 )
    {
        var loadProductsGallery = function(){
            $('.product-detail-content .img-collection').each(function(){
                $(this).height( $(this).next().height() );
            });

            myScroll = new IScroll('#gallery-wrapper', { mouseWheel: true });
        }

        $(window).resize(loadProductsGallery);
        loadProductsGallery();

        /*
         * Gallery in product
         */
        var productsCarousel = $('.product-carousel').owlCarousel({
            loop: false,
            nav: false,
            items : 1,
            onInitialized : loadProductsGallery,
            onResize : loadProductsGallery,
        });

        //Go to specific slide
        $('.product-detail-content .img-collection a').click(function(){
            productsCarousel.trigger('to.owl.carousel', $(this).index());
            return false;
        });
    }

    $('.info-carousel').owlCarousel({
        autoplay: true,
        autoplayTimeout: 2000,
        loop: false,
        nav: false,
        items : 1,
    });

    /*
     * Top products on homepage
     */
    $('.owl-products').each(function(){
        $(this).owlCarousel({
            margin: $(document).width() >= 1000 ? 20 : 5,
            loop: false,
            nav: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive:{
                0:{
                    items:2
                },
                1000:{
                    items: $(this).attr('data-items')||5,
                }
            }
        });
    })


    /*
     * Already has account button
     */
     $('#logIn').click(function(){
        $(this).parent().next().slideDown();

        $(this).prev().remove();
        $(this).remove();
     });

    /*
     * Datepicker in form
     */
    (function(){
        //Fix for vuejs
        window.js_date_event = document.createEvent('HTMLEvents');
        var dispached = false;

        js_date_event.initEvent('change', true, true);

        $('.js_date').each(function(){
            $(this).datepicker({
                autoclose: true,
                format: 'dd.mm.yyyy',
                language: 'sk',
                startDate: $(this).attr('data-disable-past') == 1 ? new Date() : null
            }).on('change', function(){
                if ( dispached == false )
                {
                    dispached = true;
                    this.dispatchEvent(js_date_event);
                } else {
                    dispached = false;
                }
            });
        })
    })();

    /*
     * Company filler
     */
    $('.company_filler input[name="company_name"]').each(function(){
        var input = $(this),
            ul = input.parent().find('ul');

        //If search wrapper does not exists
        if ( ul.length == 0 ){
            input.parent().append('<ul></ul>');
            ul = input.parent().find('ul');
        }

        var showList = function(){
            var value = $(this).val();

            if ( !value || value && value.length <= 3 )
                return;

            $.get(window.Laravel.requests.basket.getCompanyList, { name : value }, function(response){
                ul.find('li').remove();

                for ( var name in response )
                    ul.append('<li data-action="'+response[name]+'">'+name+'</li>');
            });
        };

        input.keyup(_.debounce(showList, 300)).click(showList).blur(_.debounce(function(e){
            if ( ul.find('i').length == 0 )
                ul.find('li').remove();
        }, 100))

        ul.on('click', 'li', function(){

            if ( $(this).find('i').length == 0 )
                $(this).prepend('<i class="fa fa-spin fa-refresh"></i>');
            else
                return;

            $.get(window.Laravel.requests.basket.getCompanyAction, { action : $(this).attr('data-action') }, function(response){
                ul.find('li').remove();

                for ( var key in response )
                    input.closest('form').find('input[name="'+key+'"]').val(response[key]);
            });
        });
    })

    /*
     * On delivery change
     */
    $('.cart-payment input[name="delivery"]').change(function(){
        if ( $(this).val() == '0' )
            $('.different_delivery').removeClass('hidden');
        else
            $('.different_delivery').addClass('hidden');

        $('.basket-select-city').change();
    });

    /*
     * On password change
     */
    $('.cart-payment input[name="account"]').change(function(){
        if ( $(this).val() == '1' )
            $('#show-password').removeClass('hidden');
        else
            $('#show-password').addClass('hidden');
    });

    /*
     * Show hide delivery fields in basket
     */
    $('#selectDeliveryRow').change(function(){
        var value = $(this).find('option:selected').attr('data-value'),
            box = $('.delivery-box');

        //Reset fields
        if ( !value )
        {
            box.find('input').not(':disabled').val('');
        }

        //Fill fields from delivery
        else {
            var data = JSON.parse(value);

            box.find('select[name="delivery_city"]').val(data['city_id']).trigger("chosen:updated");

            box.find('input[name="delivery_street"]').val(data['street']);
        }

        box[!value ? 'show' : 'hide']();
    }).change();

    /*
     * On company
     */
    $('.cart-payment input[name="company"].change').change(function(){
        $('.company_row').toggleClass('hidden');
    });

    $('#company_profile').change(function(){
        var checked = $(this).is(':checked');

        $('#company_data').css('display', checked ? 'block' : 'none');

        $('.company_row').each(function(){
            var display = (checked && $(this).hasClass('hidden')
                                ? 'block !important'
                                : (!checked && !$(this).hasClass('hidden') ? 'block' : 'none')
                          );

            $(this).attr('style', 'display:' + display);
        });
    }).change();

    window.isMobilDevice = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));

    /*
     * Choosen selectbox
     */
    if ( ! window.isMobilDevice )
    {
        var rebuildChosenSelects = function(){
            $('.chosen-select').chosen({max_selected_options: 5});
        };
        rebuildChosenSelects();
    }

    /*
     * Select city in basket
     */
    $('.basket-select-city').change(function(){
        var val = $(this).val(),
            delivery = window.Laravel.data.delivery;

        if ( val && val == '0' )
        {
            $(this).prev().removeClass('hidden').attr('name', $(this).attr('name')).focus();
            $(this).chosen("destroy").remove();
        }
    });

    /*
     * Cookies
     * https://cookieconsent.insites.com/download/#
     */
    if ( window.cookieconsent ) {
        window.cookieconsent.run({
            "notice_banner_type": "simple",
            "consent_type": "express",
            "palette": "light",
            "language": "sk",
            "page_load_consent_levels":["strictly-necessary", 'tracking', 'functionality'],
            "notice_banner_reject_button_hide":false,
            "preferences_center_close_button_hide":false,
            "page_refresh_confirmation_buttons":false,
            "website_name": "Qualit",
            "website_privacy_policy_url": window.Laravel.data.cookies_link
        });
    }
    // window.cookieconsent.initialise({
    //   "palette": {
    //     "popup": {
    //       "background": "#edeff5",
    //       "text": "#838391"
    //     },
    //     "button": {
    //       "background": "#2cad6a"
    //     }
    //   },
    //   "content": {
    //     "message": "Táto webová stránka používa súbory cookie na zlepšenie používateľskej skúsenosti a zabezpečenie svojho efektívneho fungovania.",
    //     "dismiss": "Súhlasim",
    //     "link": "Čítaj viac",
    //     "href": window.Laravel.data.cookies_link
    //   }
    // });

    /*
     * Ajax response
     */
    window.ajaxResponse = function(response)
    {
        console.log('response', response);

        if ( 'error' in response )
        {
            window.vueApp.setMessage(response.error, 'error');

            if ( 'callback' in response )
                eval(response.callback);
        } else if ( 'message' in response )
        {
            try {
                if ( 'events' in response )
                    eval(response.events);
            } catch(e){
                console.error(e);
            }

            window.vueApp.setMessage(response.message, 'success', null, null, function(){
                if ( 'callback' in response )
                    eval(response.callback);
            });
        } else if ( 'redirect' in response )
        {
            if ( response.redirect == window.location.href )
                return window.location.reload();

            window.location.href = response.redirect;
        } else if ( 'callback' in response )
        {
            eval(response.callback);
        }
    }

    window.errorResponse = function(response)
    {
        window.vueApp.setMessage(__('Nastala nečakaná chyba, skúste neskôr prosím.'), 'error');
    }

    $('body').on('click', '.add-delivery', function(){
        var row = $(this).parent().parent();
            row.find('.chosen-select').chosen('destroy');

        var cloned = row.clone();

            //Reset values exept disabled value
            cloned.find('select, input').not(':disabled').val('')

            //Change name attributes for multiple fields
            .each(function(){
                var name = $(this).attr('name');

                if ( row.index() == 0 && name )
                    $(this).attr('name', 'delivery['+name+'][]');
            });

        //Append row at the end
        row.parent().append(cloned);

        rebuildChosenSelects();
    }).on('click', '.remove-delivery', function(){
        $(this).parent().parent().remove();
    });

    $('form.autoAjax').each(function(){
        $(this).find('input, select, textarea').mouseenter(function(){
            $(this).attr('data-original-title', $(this).attr('placeholder'));
        }).mouseleave(function(){
            $(this).tooltip('hide');
        }).attr('data-toggle', 'tooltip').tooltip();

        /*
         * Bind form values
         */
        var data = $(this).attr('data-row');

        if ( data )
        {
            var data = $.parseJSON( data );

            for ( key in data )
            {
                var input = $(this).find('*[name="'+key+'"], *[data-field-name="'+key+'"]'),
                    value = data[key];

                if ( input.is('select') )
                    input.val(data[key]).change().trigger("chosen:updated");
                else if ( input.is('input:radio') || input.is('input:checkbox') )
                {
                    if ( value === true )
                        value = 1;
                    else if ( value === false )
                        value = 0;

                    input = $(this).find('*[name="'+key+'"][value="'+value+'"]');
                    input.prop("checked", true).change();
                } else {
                    if ( value === true )
                        value = 1;
                    else if ( value === false )
                        value = 0;

                    input.val(value).change();
                }
            }
        }

        var stop = false;

        /*
         * After submit form
         */
        $(this).submit(function(){
            if ( stop == true )
                return false;

            stop = true;

            var form = $(this);

            window.resetErrors = function(){
                form.find('.message').hide();
                form.find('span.error').remove();
                form.find('input.error, select.error, textarea.error').removeClass('error');

                var submit = form.find('*[type="submit"]').removeClass('hidden');

                if ( submit.next().hasClass('loading') )
                    submit.next().addClass('hidden');
            };

            var addLoading = function(){
                var submit = form.find('*[type="submit"]');

                if ( submit.next().hasClass('loading') )
                {
                    submit.toggleClass('hidden');
                    submit.next().toggleClass('hidden');
                }
            }

            resetErrors();
            addLoading();

            var submit = form.find('*[type="submit"]');

            if ( submit.next().hasClass('hidden') && submit.next().is('button') )
            {
                submit.toggleClass('hidden');
                submit.next().toggleClass('hidden');
            }

            form.ajaxSubmit({
              url: form.attr('data-action'),
              success: function(response){
                resetErrors();

                stop = false;

                if ( form.hasClass('autoReset') && !('error' in response) )
                    form.find('input, select, textarea').not('input[name="_token"], input[type="submit"], input[type="hidden"]').val('');

                return ajaxResponse(response);
              },
              uploadProgress(event, position, total, percents){
                uploadProgress(percents);
              },
              error: function(response){
                resetErrors();

                stop = false;

                if ( response.status == 422 || response.status == 403 ){

                    if ( response.status == 422 )
                    {
                        var obj = response.responseJSON;

                        //Laravel 5.5 provides validation errors in errors object.
                        if ( 'errors' in obj && !('length' in obj.errors) )
                            obj = obj.errors;

                        for ( var key in obj )
                        {
                            var message = $.isArray(obj[key]) ? obj[key][0] : obj[key];

                            form.find('input[name="'+key+'"], select[name="'+key+'"], textarea[name="'+key+'"]').first().addClass('error').keyup(function(){
                                $(this).find('span.error').remove();
                                $(this).find('.error').removeClass('error');
                            }).each(function(){
                                if ( ! form.hasClass('no-message') ){
                                    var error = '<span class="error">'+message+'</span>';

                                    if ( $(this).parent().hasClass('error-next') )
                                        $(this).parent().after(error);
                                    else if ( $(this).next().hasClass('chosen-container') )
                                        $(this).next().after(error);
                                    else
                                        $(this).after(error);
                                }
                            });
                        }

                        if ( ! form.hasClass('prevent-modal') )
                            window.vueApp.setMessage(__('Vypĺnte prosím všetky potrebné položky správne.'), 'error');
                    }
                } else {
                    window.errorResponse();
                }
              }
            });

            return false;
        });
    });
});